/**
 * 解析 /pricing?promo=XXX 的 query 参数。
 * 用于 Dealer 二维码扫描深链 (v0.5)。
 */
import { useSearchParams } from 'react-router-dom';

export function usePromoFromUrl(): string | null {
  const [params] = useSearchParams();
  const v = params.get('promo');
  return v && v.length >= 4 ? v.toUpperCase() : null;
}
